import React from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';

type FiltersButtonProps = {
  count: number;
  open: boolean;
  onToggle: () => void;
};

export default function FiltersButton({ count, open, onToggle }: FiltersButtonProps) {
  return (
    <button
      aria-expanded={open}
      aria-label={count ? `Filters, ${count} set` : 'Filters'}
      className={`filters-button${count ? ' set' : ''}${open ? ' open' : ''}`}
      data-lens-filters-button
      onClick={onToggle}
      type="button"
    >
      <FilterListIcon fontSize="inherit" />
      Filters
      {count ? <span className="count">{count}</span> : null}
    </button>
  );
}
